import repository from "@/repository/admin/index";

export default {
    async getPatientHealthInfo({rootState, commit}) {
        const patient_id = rootState.adminDashboardMenuStore.patient_id;
        const {data} = await repository.getPatientHealthInfo({patient_id})
        commit('SET_PATIENT_HEALTH_DATA', data);
    }
}
